import { useCallback } from 'react'
import TextField from '@mui/material/TextField'
import { comparisonOperatorConfigs, Operator } from '@global/constants'
import {
  ColumnFilterPopoverMultiValueInput,
  onChangeParam,
} from './ColumnFilterPopoverMultiValueInput'
import { GenericSelect } from '../../../components/select/GenericSelect'
import { t } from '@lingui/core/macro'
import { i18n } from '@lingui/core'

interface Props {
  filterIndex: number
  filterValue: string[] | string
  operator: Operator
  onChange: (idx: number) => (obj: onChangeParam) => void
}

export const ComparisonOperatorValueField = ({
  filterIndex,
  filterValue,
  operator,
  onChange,
}: Props) => {
  const operatorConfig = comparisonOperatorConfigs[operator]
  const canHaveValueOperand = operatorConfig?.canHaveValueOperand()
  const canHaveMultipleValues = operatorConfig?.canHaveMultipleValues()

  if (canHaveMultipleValues) {
    return (
      <ColumnFilterPopoverMultiValueInput
        filterIndex={filterIndex}
        filterValue={filterValue}
        operator={operator}
        onChange={onChange}
      />
    )
  }

  const getOperatorItems = useCallback(
    config =>
      Object.entries(config?.data ?? {}).map(([key, value]) => ({
        value: key,
        text: value as string,
      })),
    [],
  )

  const handleChange = onChange(filterIndex)

  if (operatorConfig?.data) {
    const operatorItems = getOperatorItems(operatorConfig)

    return (
      <GenericSelect
        label={i18n._(operatorConfig.dataLabel)}
        name="value"
        value={filterValue}
        items={operatorItems}
        onChange={handleChange}
        noneOption={operatorConfig.noneOption}
        noneOptionLabel={i18n._(operatorConfig.noneOptionLabel)}
        required={!operatorConfig.noneOption}
        fullWidth
      />
    )
  }

  return (
    <TextField
      label={t`Value`}
      name="value"
      value={Array.isArray(filterValue) ? '' : filterValue}
      onChange={handleChange}
      disabled={!canHaveValueOperand}
      required={canHaveValueOperand}
      fullWidth
    />
  )
}
